import { render } from "./assessment-controller.vue?vue&type=template&id=0f14a1f5&ts=true"
import script from "./assessment-controller.vue?vue&type=script&lang=ts"
export * from "./assessment-controller.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__